export const messages = {
  en: {
    merchantShop: {
      queryCondition: 'Query Conditions',
      inputShopCode: 'Please enter shop code',
      inputShopName: 'Please enter shop name',
      query: 'Query',
      merchantShop: 'Merchant Shops',
      addShop: 'Add Shop',
      back: 'Back',
      shopLogo: 'Shop Logo',
      shopName: 'Shop Name',
      shopType: 'Shop Type',
      merchantName: 'Merchant Name',
      merchantAddress: 'After-sales Return Address',
      contactNumber: 'Contact Number',
      shopStatus: 'Shop Status',
      createTime: 'Create Time',
      operation: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      confirmOperation: 'Please confirm your operation',
      confirmDeleteShop: 'Confirm to delete merchant shop? Deleted data cannot be recovered, please operate carefully',
      cancel: 'Cancel',
      confirmDelete: 'Confirm Delete',
      deleteSuccess: 'Delete successfully',
      deleteFailed: 'Delete failed',
      selectShopType: 'Please select shop type',
      shopArea: 'Shop Area',
      selectProvince: 'Please select province',
      selectCity: 'Please select city',
      selectArea: 'Please select district',
      address: 'After-sales Return Address',
      inputAddress: 'Please enter after-sales return address',
      phone: 'Contact Phone',
      inputPhone: 'Please enter contact phone',
      save: 'Save',
      editShop: 'Edit Shop',
      editSuccess: 'Edit successfully',
      editFailed: 'Edit failed',
      addSuccess: 'Add successfully',
      addFailed: 'Add failed',
      shopNameMaxLength: 'Shop name must be within 200 characters',
      addressMaxLength: 'Address must be within 200 characters',
      phoneFormat: 'Invalid phone number format',
      getAreaFailed: 'Failed to get area data'
    }
  },
  zh: {
    merchantShop: {
      queryCondition: '查询条件',
      inputShopCode: '请输入商铺编号',
      inputShopName: '请输入商铺名称',
      query: '查询',
      merchantShop: '商家店铺',
      addShop: '添加店铺',
      back: '返回',
      shopLogo: '店铺logo',
      shopName: '店铺名称',
      shopType: '店铺类型',
      merchantName: '商家名称',
      merchantAddress: '售后退货地址',
      contactNumber: '联系电话',
      shopStatus: '店铺状态',
      createTime: '创建时间',
      operation: '操作',
      edit: '修改',
      delete: '删除',
      confirmOperation: '请确认您的操作',
      confirmDeleteShop: '确定删除商家店铺，删除后无法恢复，请慎重操作',
      cancel: '取消',
      confirmDelete: '确认删除',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败',
      selectShopType: '请选择商铺类型',
      shopArea: '地铺地区',
      selectProvince: '请选择省',
      selectCity: '请选择城市',
      selectArea: '请选择区县',
      address: '售后退货地址',
      inputAddress: '请填写售后退货地址',
      phone: '联系电话',
      inputPhone: '请填写联系电话',
      save: '保存',
      editShop: '修改店铺',
      editSuccess: '修改成功',
      editFailed: '修改失败',
      addSuccess: '添加成功',
      addFailed: '添加失败',
      shopNameMaxLength: '商铺名称必须在200位之内',
      addressMaxLength: '地址长度必须在200位之内',
      phoneFormat: '不是有效的手机号',
      getAreaFailed: '获取地区数据失败'
    }
  }
}